import { render, staticRenderFns } from "./LibraryChairSelectbox.vue?vue&type=template&id=6d8f5789"
import script from "./LibraryChairSelectbox.vue?vue&type=script&lang=js"
export * from "./LibraryChairSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports